var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M16.9003 12.6L9.20026 21.4C8.70026 21.9 7.90026 22 7.40026 21.5C6.90026 21 6.90026 20.2 7.30026 19.7L14.0003 12L7.30026 4.29999C6.90026 3.79999 6.90026 2.99999 7.40026 2.49999C7.90026 1.99999 8.70026 2.09999 9.20026 2.59999L16.9003 11.4C17.2003 11.8 17.2003 12.2 16.9003 12.6Z","fill":"#111930"}})
}
var staticRenderFns = []

export { render, staticRenderFns }